import { HIDDEN } from '../classnames/design-system';
import {
  IMAGE_VISIBILITY_CONTAINER,
  IMAGE_VISIBILITY_ITEM
} from '../classnames/images-visibility';

export default class ImagesVisibilityHandler {
  constructor() {
    this.container = document.querySelector(IMAGE_VISIBILITY_CONTAINER);
    this.images = this.container ? [...this.container.querySelectorAll(IMAGE_VISIBILITY_ITEM)] : [];
    this.observer = null;
  }

  initialize() {
    if (this.container && this.images.length) {
      this.setupIntersectionObserver();
    }
  }

  setupIntersectionObserver() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.loadImages();
          this.observer.disconnect(); // Disconnect after loading images
        }
      });
    }, { threshold: 0.1 });

    this.observer.observe(this.container);
  }

  loadImages() {
    this.images.forEach((image) => {
      const dataSrc = image.getAttribute('data-src');

      if (dataSrc) {
        image.style.backgroundImage = `url(${dataSrc})`;

        const imgElement = new Image();

        imgElement.src = dataSrc;
      }
    });

    this.startImageRotation();
  }

  startImageRotation() {
    setInterval(() => {
      const currentImageIndex = this.images.findIndex((img) => !img.classList.contains(HIDDEN));

      if (currentImageIndex !== -1) {
        this.images[currentImageIndex].classList.add(HIDDEN);

        const nextImageIndex = (currentImageIndex + 1) % this.images.length;

        this.images[nextImageIndex].classList.remove(HIDDEN);
      }
    }, 2000);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ImagesVisibilityHandler().initialize();
});
